import { defineMessage } from 'react-intl';
import type { IntlShape } from 'react-intl';
import * as yup from 'yup';

import { validateIBAN } from './IBANFormValidation';

const requiredFieldMessage = defineMessage({
    id: '_.link_bank_account.required_field',
    defaultMessage: 'Required field'
});

const invalidIBANMessage = defineMessage({
    id: '_.link_bank_account.invalid_iban',
    defaultMessage: 'Invalid IBAN'
});

const mandateRequiredMessage = defineMessage({
    id: '_.link_bank_account.mandate_required',
    defaultMessage:
        'Check the box to continue. If you do not want a direct debit, please contact us by phone.'
});

export const createLinkBankAccountSchema = (
    intl: IntlShape,
    country: string
) => {
    if (country === 'DE') {
        return yup.object({
            iban: yup
                .string()
                .test(
                    'valid-iban',
                    intl.formatMessage(invalidIBANMessage),
                    (value) => Boolean(validateIBAN({ iban: value }))
                ),
            directDebitMandate: yup
                .boolean()
                .oneOf([true], intl.formatMessage(mandateRequiredMessage))
        });
    }

    const required = intl.formatMessage(requiredFieldMessage);

    return yup.object({
        accountNumber: yup
            .string()
            .test(
                'account-number-length',
                required,
                (value) => !!value && value.length === 8
            ),
        sortCode: yup
            .string()
            .test(
                'sort-code-length',
                required,
                (value) => !!value && value.length === 8
            )
    });
};
